var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MarkdownDocument',{attrs:{"title":("v" + (_vm.$route.params.id) + " Changelog"),"filename":(_vm.STORAGE_URL + "/changelogs/" + (_vm.$route.params.id) + ".md"),"standard":_vm.MD_STANDARD.SYSTEM}},[_vm._v(" Changelog Not Found ")])}
var staticRenderFns = []

export { render, staticRenderFns }